import { useMemo } from 'react';

import { useBookmakerFromCode } from './useBookmakerFromCode';

export const useOffersSpecialBookie = (bookieCode: string) => {
  const bookmaker = useBookmakerFromCode(bookieCode);
  return useMemo(() => bookmaker?.offers.specialOffers || [], [bookmaker]);
};
